var module = angular.module('components');
module.component('caFormGroupRowOther', {
    templateUrl: 'components/genericcomponents/formgrouprowother.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        label: '<'
    },
    transclude: true
});
